/**
 * 埋点按钮组件
 *
 * @description antd Button 的埋点包装，点击时先上报 Umami 事件再执行业务 onClick。
 * 用法：把 `import { Button } from 'antd'` 换成 TrackButton 并传入 trackName 即可。
 */

import { Button, type ButtonProps } from 'antd';
import React from 'react';
import { trackEvent } from '@/utils/tracking';

export interface TrackButtonProps extends ButtonProps {
  /** 埋点事件名，建议使用「模块-动作」格式，如「人才搜索-加入私池」 */
  trackName: string;
  /** 可选附加属性，上报时自动合并当前页面路径 page */
  trackData?: Record<string, unknown>;
}

export const TrackButton: React.FC<TrackButtonProps> = ({
  trackName,
  trackData,
  onClick,
  ...rest
}) => {
  const handleClick = React.useCallback(
    (event: React.MouseEvent<HTMLElement>) => {
      trackEvent(trackName, {
        page: window.location.pathname,
        ...trackData,
      });
      onClick?.(event);
    },
    [trackName, trackData, onClick],
  );

  return <Button {...rest} onClick={handleClick} />;
};

export default TrackButton;
